module.exports = __webpack_public_path__ + "static/img/WisdomSiteZhiliang.a5528e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WisdomSite/WisdomSiteZhiliang.png
// module id = 3y++
// module chunks = 12